import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'

export const formatTextWithAdSetNames = ({
  ads,
  campaign,
  lineItems,
  lineItem,
  lineItemWasLoaded,
  lineItemsWasLoaded
}) => {
  if (!campaign || !ads) {
    console.warn('Missing campaign or ads data.')
    return ''
  }

  // Group ads by line item ID
  const adsByLineItem = {}

  ads.forEach(ad => {
    const lineItemId = ad.line_item_id

    if (!lineItemId) {
      // Fallback for ads without line_item_id
      if (!adsByLineItem['unknown']) {
        adsByLineItem['unknown'] = []
      }
      adsByLineItem['unknown'].push(ad)
      return
    }

    if (!adsByLineItem[lineItemId]) {
      adsByLineItem[lineItemId] = []
    }
    adsByLineItem[lineItemId].push(ad)
  })

  // Build the text to copy
  const textParts = [
    `Campaign Name: ${campaign.name}`,
    '' // new line
  ]

  // Check if single or multiple lineItems are loaded
  if (lineItemsWasLoaded && lineItems) {
    // Multiple line items loaded - find parent lineItem by id
    Object.entries(adsByLineItem).forEach(([lineItemId, adsInLineItem]) => {
      if (lineItemId === 'unknown') {
        // Handle ads without line_item_id
        textParts.push(`Ad Set Name: Unknown`)
      } else {
        // Find the line item by ID
        const foundLineItem = lineItems.find(item => item.id === lineItemId)
        textParts.push(`Ad Set Name: ${foundLineItem ? foundLineItem.name : 'Unknown'}`)
      }

      // Add ads for this line item
      adsInLineItem.forEach(ad => {
        textParts.push(`${ad.name}: ${ad.preview}`)
      })

      textParts.push('') // Add empty line between line items
    })
  } else if (lineItemWasLoaded && lineItem) {
    // Single line item loaded - use its name
    textParts.push(`Ad Set Name: ${lineItem.name}`)

    // Add all ads
    ads.forEach(ad => {
      textParts.push(`${ad.name}: ${ad.preview}`)
    })
  } else {
    // Fallback if no line items are loaded
    ads.forEach(ad => {
      textParts.push(`${ad.name}: ${ad.preview}`)
    })
  }

  return textParts.join('\n')
}

export const formatTextWithoutAdSetNames = ({ ads, campaign }) => {
  if (!campaign || !ads) {
    console.warn('Missing campaign or ads data.')
    return ''
  }

  // Build the text to copy
  const textParts = [
    `Campaign Name: ${campaign.name}`,
    '' // new line
  ]

  // Add all ads without ad set names
  ads.forEach(ad => {
    textParts.push(`${ad.name}: ${ad.preview}`)
  })

  return textParts.join('\n')
}

export const formatTextByPlatform = ({
  ads,
  campaign,
  lineItems,
  lineItem,
  lineItemWasLoaded,
  lineItemsWasLoaded,
  selectedPlatform
}) => {
  if (selectedPlatform === FACEBOOK_PLATFORM) {
    return formatTextWithAdSetNames({
      ads,
      campaign,
      lineItems,
      lineItem,
      lineItemWasLoaded,
      lineItemsWasLoaded
    })
  }

  return formatTextWithoutAdSetNames({ ads, campaign })
}
